import {
  Component,
  InputSignal,
  InputSignalWithTransform,
  booleanAttribute,
  computed,
  input
} from '@angular/core';

export type DividerType = 'primary' | 'secondary';

@Component({
  selector: 'td-wb-divider',
  styleUrls: ['./divider.component.scss'],
  template: '',
  host: {
    '[class.td-wb-divider]': '!isVertical() && !isSecondary()',
    '[class.td-wb-divider__secondary]': '!isVertical() && isSecondary()',
    '[class.td-wb-divider__vertical]': 'isVertical() && !isSecondary()',
    '[class.td-wb-divider__vertical-secondary]': 'isVertical() && isSecondary()'
  }
})
export class DividerComponent {
  readonly dividerType: InputSignal<DividerType> = input<DividerType>('primary');
  readonly vertical: InputSignalWithTransform<boolean, unknown> = input(false, { transform: booleanAttribute });

  protected readonly isVertical: () => boolean = computed(() => this.vertical());
  protected readonly isSecondary: () => boolean = computed(() => this.dividerType() === 'secondary');
}
